import {Component, EventEmitter, Input, OnInit, Output, ViewChild, inject} from '@angular/core';
import {ClsListaArchivos} from '../../../../core/models/cls-storage';
import {ClsConfig} from '../../../../util/cls-config';
import {VtnGenericaComponent} from '../vtn-generica/vtn-generica.component';
import {AppPresupuestosService} from '../../../../core/services/app-presupuestos.service';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IGridCellEventArgs } from '@infragistics/igniteui-angular/grids/core';
import {MasOpcionesGridComponent} from '../../controles/mas-opciones-grid/mas-opciones-grid.component';
import {FiltroGeneralComponent} from '../../controles/filtro-general/filtro-general.component';
import {EnumMasOpciones, EnumPosicionBtn} from '../../../../core/models/enum/enum-mas-opciones';
import {TranslateModule} from '@ngx-translate/core';
import {INeodataBtnsFooter} from "../../../../core/models/interfaces/generico-interface";
import {TipoMensajesService} from "../../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../../core/pipes/summary-pipe-neo.pipe";

@Component({
  selector: 'app-lista-documentos',
  templateUrl: './lista-documentos.component.html',
  styleUrls: ['./lista-documentos.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralComponent,
    MasOpcionesGridComponent,
    IgxIconComponent,
    SummaryPipeNeoPipe,
  ]
})
export class ListaDocumentosComponent extends ClsConfig implements OnInit {
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);

  @ViewChild('gridListadoDoc', {static: true})
  public gridListadoDoc: IgxGridComponent;
  @ViewChild('masOpciones', {read: MasOpcionesGridComponent, static: true})
  public masOpciones: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralComponent, static: true})
  public filtroGeneral: FiltroGeneralComponent;

  @Input()
  public listaArchivos: ClsListaArchivos[] = [];
  @Output()
  public documentoSeleccionado: EventEmitter<ClsListaArchivos> = new EventEmitter<ClsListaArchivos>();

  public vtnGenerico: VtnGenericaComponent;

  ngOnInit(): void {
    // EVENTO DE BOTONES VENTANA
    this.vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
      switch (btn.id) {
        case 'ACEPTAR':
          this.registroSeleccionado();
          break;
        default: // cancelar
          this.close();
      }
    });
  }

  public open() {
    this.vtnGenerico.btnsAccion = [
      {
        id: 'ACEPTAR',
        texto: 'BOTONES.ACEPTAR',
        titulo: 'BOTONES.ACEPTAR',
        icono: '',
        tipoBoton: 'contained',
        posicion: EnumPosicionBtn.DERECHO
      },
      {
        id: 'CANCELAR',
        texto: 'BOTONES.CANCELAR',
        titulo: 'BOTONES.CANCELAR',
        icono: '',
        tipoBoton: 'flat',
        posicion: EnumPosicionBtn.DERECHO
      }
    ];
    this.vtnGenerico.open(500, 870, 'MENSAJES.GRALS.DOCUMENTOS', 'description');
  }

  public doubleClick(evt: IGridCellEventArgs) {
    const rowData: ClsListaArchivos = evt.cell.row.data;
    this.emitirRespuesta(rowData);
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridListadoDoc.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData: ClsListaArchivos = this.gridListadoDoc.getRowData(rowSeleccionados[0]);
      this.emitirRespuesta(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  private emitirRespuesta(data: ClsListaArchivos) {
    this.documentoSeleccionado.emit(data);
    this.close();
  }

  public close() {
    this.vtnGenerico.close();
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridListadoDoc.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridListadoDoc.filteringLogic = FilteringLogic.Or;
    this.gridListadoDoc.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
